var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"promptpai-snippet-button"},[_c('img',{staticClass:"promptpai-snippet-logo",attrs:{"src":_vm.util.getImagePath('promptpai_icon_badge@2x.png'),"srcset":_vm.util.getImageSet('promptpai_icon_badge')}}),_vm._v(" "),_c('div',{staticClass:"promptpai-snippet-id"},[_vm._v(_vm._s(_vm.displayId))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-091debf4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PromptPaiSnippetButton.vue
// module id = null
// module chunks = 